import SemanticList from '../SemanticList';
import Stack from '../Stack';
import styled from 'styled-components';

export const Accordion = styled.ul`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;
    background-color: ${({ theme }) => theme.gray_7};
    box-shadow:
        0px 2px 5px rgba(0, 0, 0, 0.12),
        inset 2px 0px 0px
            ${({ theme, $isActive }) =>
                $isActive ? theme.purple_4 : theme.gray_7};
    border-radius: ${({ theme }) => theme.borderRadius_md};
`;

export const NestedAccordion = styled.ul`
    display: flex;
    flex-direction: column;
    margin: ${({ theme, $isActive }) =>
        $isActive ? `0 ${theme.space_8}px ${theme.space_8}px` : 0};
    margin-top: 0;
    padding: 0;
    gap: ${({ theme }) => theme.space_2}px;
    list-style: none;
    background-color: ${() => 'transparent'};
`;

export const NestedAccordionGrayBg = styled(NestedAccordion)`
    background-color: ${({ theme }) => theme.gray_50};
    padding: ${({ $isActive }) => ($isActive ? `.75rem` : '0')};
    padding-top: 0;
    margin: 0;
`;

export const AccordionItem = styled.li`
    background-color: ${({ theme, $isOpen }) =>
        $isOpen ? 'transparent' : theme.gray_7};
    border-top: solid 1px ${({ theme }) => theme.gray_5};

    &:hover > * {
        background-color: ${({ theme, $isOpen }) =>
            $isOpen ? 'transparent' : theme.gray_7};
    }
`;

export const NestedAccordionItem = styled.li`
    background-color: ${({ $FilterAccordionNestedItemBgColor }) =>
        $FilterAccordionNestedItemBgColor || 'transparent'};
    border: solid 1px
        ${({ theme, $isOpen }) => ($isOpen ? theme.purple_1 : theme.gray_300)};
    border-radius: ${({ theme }) => theme.borderRadius_md};
`;

export const AccordionTitleItem = styled.li`
    font-family: ${({ theme }) => theme.style_primary};
    background-color: ${({ theme }) => theme.gray_6};
    padding: ${({ theme }) => `${theme.space_5}px ${theme.space_7}px`};
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const AccordionTitle = styled.span`
    font-weight: ${({ theme }) => theme.fontBold};
    font-size: ${({ theme }) => theme.fontSize_base};
    line-height: ${({ theme }) => theme.space_10}px;
    letter-spacing: -0.01em;
    color: ${({ theme }) => theme.gray_1};
    text-transform: capitalize;
`;

export const AccordionPanel = styled(Stack).attrs(
    ({
        as = SemanticList,
        $maxPanelHeight = 'unset',
        $space = (theme) => `${theme.space_5}px`,
    }) => ({
        as,
        $maxPanelHeight,
        $space,
    }),
)`
    padding: ${({ theme }) => `0 ${theme.space_8}px ${theme.space_8}px`};
    line-height: 1;
    overflow-y: auto;
    max-height: ${({ $maxPanelHeight }) => $maxPanelHeight};
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    & > * {
        display: flex;
        flex-direction: column;
    }
`;

export const ChipAccordionPanel = styled(Stack).attrs(
    ({
        as = SemanticList,
        $space = (theme) => `${theme.space_2}px`,
        $direction = 'row',
    }) => ({
        as,
        $space,
        $direction,
    }),
)`
    background-color: ${({ theme, $bgColor }) => $bgColor || theme.gray_6};
    margin-top: -${({ theme }) => theme.space_3}px;
    padding: ${({ theme }) => theme.space_7}px;
    padding-top: 0;
    line-height: 26px;

    & > * {
        display: inline-block;
        ${({ $liMaxWidth }) => $liMaxWidth && `max-width: ${$liMaxWidth};`}
    }
`;

export const AccordionButtonIconWrapper = styled.span`
    color: ${({ theme, isActive }) =>
        isActive ? theme.purple_1 : theme.gray_4};
    font-size: ${({ theme }) => theme.space_9}px;
    margin-right: ${({ theme }) => theme.space_5}px;
    display: flex;
    align-items: center;
`;

export const AccordionButton = styled.button.attrs(({ type = 'button' }) => ({
    type,
}))`
    background-color: ${({ theme, isActive, $isOpen }) =>
        !isActive ? theme.gray_6 : 'transparent'};
    color: ${({ theme, isActive }) =>
        isActive ? theme.purple_1 : theme.gray_1};
    text-align: left;
    cursor: pointer;
    margin: 0px;
    padding: ${({ theme }) => `${theme.space_7}px`};
    font-family: ${({ theme }) => theme.style_primary};
    font-size: 1rem;
    font-weight: ${({ theme }) => theme.fontBold};
    text-transform: capitalize;
    border: 0;
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;

    &:hover {
        background-color: ${({ theme, isActive }) =>
            isActive ? 'transparent' : theme.gray_7};
    }
`;
